import { c as _c } from "react/compiler-runtime";
import { postEntitiesByFpIdAgentsExecutionByIdOptions } from '@onefootprint/fetch-dashboard';
import type { Entity, UserTimelineEventAgentExecution } from '@onefootprint/request-types/dashboard';
import { LinkButton, Shimmer } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AgentExecutionSummary from '@/components/entities/components/details/components/content/components/agent-execution-summary';
import { isPermissionError } from '@/utils/request-errors';
import AgentExecutionCompletedDrawer from './agent-execution-completed-event-drawer';
type AgentExecutionEventBodyProps = {
  data: UserTimelineEventAgentExecution['data'];
  entity: Entity;
};
const PREVIEW_MAX_HEIGHT = 120;
const AgentExecutionEventBody = t0 => {
  const $ = _c(34);
  const {
    data,
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.agentExecutionEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = node => {
      if (node) {
        setIsOverflowing(node.scrollHeight > PREVIEW_MAX_HEIGHT);
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const measureRef = t2;
  let t3;
  if ($[2] !== data.id || $[3] !== entity.id) {
    t3 = postEntitiesByFpIdAgentsExecutionByIdOptions({
      path: {
        fpId: entity.id,
        id: data.id
      }
    });
    $[2] = data.id;
    $[3] = entity.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = {
      ...t3,
      retry: false
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const outputQuery = useQuery(t4);
  if (outputQuery.isError) {
    if (isPermissionError(outputQuery.error)) {
      let t5;
      if ($[7] !== t) {
        t5 = t(_temp);
        $[7] = t;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      let t6;
      if ($[9] !== t5) {
        t6 = <p className="text-body-2 text-tertiary fp-text">{t5}</p>;
        $[9] = t5;
        $[10] = t6;
      } else {
        t6 = $[10];
      }
      return t6;
    }
    return null;
  }
  if (outputQuery.isPending) {
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex flex-col gap-2"><Shimmer height="16px" width="60%" /><Shimmer height="40px" width="100%" /></div>;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== isOverflowing) {
    t5 = isOverflowing && {
      maskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
      WebkitMaskImage: "linear-gradient(to bottom, black 60%, transparent 100%)"
    };
    $[12] = isOverflowing;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = {
      maxHeight: PREVIEW_MAX_HEIGHT,
      ...t5
    };
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== outputQuery.data) {
    t7 = <AgentExecutionSummary output={outputQuery.data} showJsonView={false} />;
    $[16] = outputQuery.data;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div ref={measureRef} className="overflow-hidden text-body-2" style={t6}>{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== isOverflowing || $[22] !== t) {
    t9 = isOverflowing && <LinkButton onClick={() => setIsDrawerOpen(true)}>{t(_temp2)}</LinkButton>;
    $[21] = isOverflowing;
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <div className="flex flex-col gap-2">{t8}{t9}</div>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsDrawerOpen(false);
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== isDrawerOpen || $[29] !== outputQuery.data) {
    t12 = <AgentExecutionCompletedDrawer open={isDrawerOpen} onClose={t11} output={outputQuery.data} />;
    $[28] = isDrawerOpen;
    $[29] = outputQuery.data;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[31] = t10;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default AgentExecutionEventBody;
function _temp($) {
  return $.permissionError;
}
function _temp2($_0) {
  return $_0.viewMore;
}